window.evergageHideSections = (function() {
  function e() {
    try {
      for (
        var a = document.getElementsByClassName('evergagePersonalizationSections'), b = 0;
        b < a.length;
        b++
      )
        a[b].parentNode.removeChild(a[b]);
      'object' === typeof window._aaq &&
        'function' === typeof window._aaq.push &&
        window._aaq.push(['personalizedContentHideTimedOut']);
      d = -1;
    } catch (c) {}
  }
  var d = -1;
  return function() {
    var a = '';
    if (0 !== arguments.length) {
      for (var b = 0; b < arguments.length; b++)
        if ('string' === typeof arguments[b])
          try {
            'body' !== arguments[b] &&
              'html' !== arguments[b] &&
              (document.querySelector(arguments[b]), '' !== a && (a += ', '), (a += arguments[b]));
          } catch (f) {}
      if ('' !== a) {
        var a = a + ' { visibility: hidden !important; }',
          b = document.head || document.getElementsByTagName('head')[0],
          c = document.createElement('style');
        c.type = 'text/css';
        c.setAttribute('class', 'evergagePersonalizationSections');
        c.styleSheet ? (c.styleSheet.cssText = a) : c.appendChild(document.createTextNode(a));
        a = 2500;
        'number' === typeof arguments[arguments.length - 1] &&
          (a = arguments[arguments.length - 1]);
        clearTimeout(d);
        d = setTimeout(function() {
          try {
            'function' === typeof window.requestAnimationFrame
              ? window.requestAnimationFrame(e)
              : e();
          } catch (a) {}
        }, a);
        b.appendChild(c);
        (window._aaq || []).push(['personalizedSectionsHaveBeenHidden']);
      }
    }
  };
})();
window.evergageHideSections('li.bread__crumb.flyout__trigger', 15000);
